module.exports = __webpack_public_path__ + "img/about-hero.b9e4f9f6.svg";